<template>
    <div>
      <design-publication-type-list></design-publication-type-list>
    </div>
  </template>
  
  <script>  
  export default {
  }
  </script>
  
  <style>
  
  </style>
  